module.exports = __webpack_public_path__ + "assets/img/hcpimg4l.c7ce2990.png";